import { validateDateRange } from "../utils/dateUtils";

type SetDate = (value: string) => void;

export const useDateRangeValidation = (
  setStartDate: SetDate,
  setEndDate: SetDate,
  setDateError: SetDate,
  maxRangeMonths?: number,
) => {
  const updateDates = (from: string, to: string) => {
    setStartDate(from);
    setEndDate(to);
    setDateError(validateDateRange(from, to, maxRangeMonths));
  };

  return {
    handleDateChange: updateDates,
    handleTypingChange: updateDates,
  };
};

export default useDateRangeValidation;
